var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isFormHidden
        ? _c(
            "form",
            {
              staticClass: "subscribe-form",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.onSubmitForm.apply(null, arguments)
                },
              },
            },
            [
              !_vm.edit
                ? _c(
                    "div",
                    {
                      staticClass:
                        "subscribe-form__container u-bottom-margin--m",
                      staticStyle: { "max-width": "700px" },
                    },
                    [
                      _c("z-input", {
                        attrs: {
                          required: "",
                          name: "email",
                          type: "email",
                          value: _vm.params.email,
                          placeholder: _vm.text.labelEmail[_vm.lang],
                        },
                        on: { input: _vm.onInput },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "subscribe-form__container u-bottom-margin--m" },
                _vm._l(_vm.rubrics, function (item) {
                  return _c(
                    "z-checkbox",
                    {
                      key: item.id,
                      attrs: { name: item.id, checked: item.selected },
                      on: {
                        change: function ($event) {
                          return _vm.onChange({
                            name: "rubrics",
                            value: item.id,
                          })
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.name))]
                  )
                }),
                1
              ),
              _vm._v(" "),
              !_vm.edit
                ? _c(
                    "div",
                    {
                      staticClass:
                        "subscribe-form__container u-bottom-margin--m",
                    },
                    [
                      _c(
                        "z-checkbox",
                        {
                          attrs: { name: "agreement" },
                          on: { change: _vm.onChange },
                          model: {
                            value: _vm.params.agreement,
                            callback: function ($$v) {
                              _vm.$set(_vm.params, "agreement", $$v)
                            },
                            expression: "params.agreement",
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.text.agreement[_vm.lang]),
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "z-button",
                {
                  staticClass: "subscribe-form__btn",
                  attrs: {
                    kind: "primary",
                    size: "m",
                    type: "submit",
                    disabled: !_vm.isSubmitAvalible,
                  },
                },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.text.submitBtn[_vm.lang]),
                    },
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isSendSuccess
        ? [
            _c(
              "p",
              {
                class: [
                  "subscribe-form-msg",
                  { "subscribe-form-msg--green": _vm.edit },
                ],
              },
              [_c("span", { domProps: { innerHTML: _vm._s(_vm.successMsg) } })]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }